// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.debug-info {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  height: 30px;
  justify-content: space-between;
}
.debug-info__value {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin: 0 auto 0 6px;
}
.debug-info__caption {
  flex: 0 0 80px;
  font-weight: bold;
}
.debug-info_mobile {
  height: unset;
}
.debug-info_mobile .debug-info__info-values {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 12px;
  flex: 1;
}
.debug-info_mobile .debug-info__info-line {
  display: flex;
}
.debug-info_mobile .debug-info__info-line:not(:last-child) {
  margin-bottom: 4px;
}
.debug-info_mobile .debug-info__caption {
  flex-shrink: 1;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/DialogErrorWithTabs/DebugInfo/DebugInfo.scss","webpack://./node_modules/@gravity-ui/uikit/styles/mixins.scss"],"names":[],"mappings":"AAEA;EAEI,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,8BAAA;AAFJ;AAII;EACI,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,oBAAA;AAFR;AAKI;EACI,cAAA;EACA,iBAAA;AAHR;AAMI;EACI,aAAA;AAJR;AAMQ;ECrBJ,mBAAA;EACA,gBAAA;EACA,uBAH4B;EDwBpB,kBAAA;EACA,OAAA;AAFZ;AAKQ;EACI,aAAA;AAHZ;AAKY;EACI,kBAAA;AAHhB;AAOQ;EACI,cAAA;AALZ","sourcesContent":[".debug-info {\n  margin-bottom: 15px;\n  display: flex;\n  align-items: center;\n  height: 30px;\n  justify-content: space-between;\n}\n.debug-info__value {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  margin: 0 auto 0 6px;\n}\n.debug-info__caption {\n  flex: 0 0 80px;\n  font-weight: bold;\n}\n.debug-info_mobile {\n  height: unset;\n}\n.debug-info_mobile .debug-info__info-values {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-right: 12px;\n  flex: 1;\n}\n.debug-info_mobile .debug-info__info-line {\n  display: flex;\n}\n.debug-info_mobile .debug-info__info-line:not(:last-child) {\n  margin-bottom: 4px;\n}\n.debug-info_mobile .debug-info__caption {\n  flex-shrink: 1;\n}",null],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
